import FindScreenMdl from '../uc/findScreen/FindScreenMdl';

const InventoryReducer = {
    findScreenMdl: FindScreenMdl,
};

export default InventoryReducer;
